import './App.css';

function App() {
  return null; // This component doesn't render anything
}

export default App;
